// 3rd-party wrapped
import { area } from '3rd-party-wrappers/turf';

// util
import { calculateDifference } from 'geometry/geojson/difference';
import { calculateUnion } from 'geometry/geojson/union';

/** Determines if one geojson object fully contains another.
    @param geoContainer
    @param geoCheck
    @return True if the geometries of geoCheck are fully inside of geoContainer. */
export const contains = function(geoContainer, geoCheck) {
  const library = ['MFOGEL'];
  const param = {useLibraries: library};
  const u = calculateUnion({geoJsons: [geoContainer, geoCheck], ...param});
  const d = calculateDifference(u, geoContainer, library);

  if (!d) { return true; }

  /* Check for close enough match. d represents every part of geoCheck that didn't fit inside of geoContainer. If the
     area of the parts that don't fit is small enough, it can be attributed to negligible artifacts of geometric
     operations performed on zones. This is measured as a ratio of the area that didn't fit (d) to the area of
     geoCheck, so that a larger zone will have a larger tolerance for artifacts. */
  const CLOSE_ENOUGH = 0.001; // One tenth of a percent (.1%) of geoCheck can stick outside of the container.
  const areaC = area(geoCheck);
  const areaD = area(d);
  const diffRatio = areaD / areaC;

  return (diffRatio < CLOSE_ENOUGH);
};
